const dsUtilities = (($) => {

    const base_url = 'index.php?route=',
        menu = 'div#lhs-categories-menu',
        modal_cart = 'div.unavailable-modal',
        modal_fave = '#added-to-fav-window',
        modal_images = {'fave' : 'fav_small_selected', 'list' : 'add_to_list_small'},
        rem = function rem() {
            const html = document.getElementsByTagName('html')[0];
            return function () {
                return parseInt(window.getComputedStyle(html)['fontSize']);
            }
        }();

    function getEnv() {
        switch (doorstep.url) {
            case 'https://www.doorsteporganics.com.au/':
                return 'prod';
            case 'https://staging.doorsteporganics.com.au/':
                return 'dev';
            default:
                return 'local';
        }
    }

    function getType(el) {
        return $(el).closest('div[data-type]').attr('data-type');
    }

    function getView(el) {
        return $(el).closest('div[data-view]').attr('data-view');
    }

    function getSubView(el) {
        return $(el).closest('div[data-view]').attr('data-subview');
    }

    function getKey(el) {
        return parseInt($(el).closest('div[data-key]').attr('data-key'));
    }

    function getId(el) {
        return $(el).closest('div[data-id]').attr('data-id');
    }

    function doModal(type, message) {
        $('span#modal-message').html(message);
        $('img#modal-image').attr('src', `/dist/images/${modal_images[type]}.svg`);
        $('#added-to-fav-modal,' + modal_fave).css('display', 'block');
        $(modal_fave)
            .css('-webkit-animation-play-state, animation-play-state', 'running')
            .before($(modal_fave).clone(true))
            .remove();
    }

    function htmlDecode(input){
        const e = document.createElement('textarea');
        e.innerHTML = input;
        return e.childNodes.length === 0 ? '' : e.childNodes[0].nodeValue;
    }

    function status(status) {
        const statuses = {
            4  : 'Packing',
            17 : 'In Transit',
            20 : 'Packing'
        };
    }

    function state_to_zone(state) {
        const states = {
            'ACT' : 191,
            'NSW' : 192,
            'NT'  : 193,
            'QLD' : 194,
            'SA'  : 195,
            'TAS' : 196,
            'VIC' : 197,
            'WA'  : 198
        };
        return states[state] !== undefined ? states[state] : '';
    }

    function zone_to_state(zone) {
        const zones = {
            191 : 'ACT',
            192 : 'NSW',
            193 : 'NT',
            194 : 'QLD',
            195 : 'SA',
            196 : 'TAS',
            197 : 'VIC',
            198 : 'WA'
        };
        return zones[zone] !== undefined ? zones[zone] : '';
    }

    function url_param(sParam) {
        const sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&');
        let sParameterName, i;
        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');
            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
        }
        return '';
    }

    function setNavSignOut() {
        $('div.nav_container > a').last().attr('href', '/index.php?route=account/logout').html('<img src="/dist/images/sign_out.svg" alt="Sign in">Sign out');
    }

    function getSelectedAddress() {
        let BreakException = {},
            selected = {};
        try {
            doorstep.addresses.forEach(function(address) {
                if (address.selected) {
                    selected = address;
                    throw BreakException;
                }
            });
        } catch (e) {}
        return selected;
    }

    function dow() {
        return ['', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
    }

    function cartModal(step = 0, message = '', close = '', products = [], url = '') {
        const close_button = `${modal_cart} button.modal-close`;
        if (message.length > 0) {
            $(`${modal_cart} h3#modal-message`).html(message);
        }
        if (products.length > 0) {
            dsCheckout.modalUnavailable(step, products);
        }
        if (close.length > 0) {
            $(close_button).attr('data-url', close);
        }
        if (products.length > 0) {
            $(`${modal_cart} button#modal-remove, ${modal_cart} a.modal-close`).removeClass('hide');
            $(close_button).addClass('hide');
        } else {
            $(`${modal_cart} button#modal-remove, ${modal_cart} a.modal-close`).addClass('hide');
            $(close_button).removeClass('hide');
        }
        if (url.length > 0) {
            $(close_button).on('click', function () {
                location.href = url;
            });
        }
        $(modal_cart).removeClass('hide');
    }

    function cartClose() {
        if (doorstep.page_type === 'checkout') {
            //dsCheckout.setQuickEdit(false);
        }
        $(`${modal_cart} div#unavailable-products`).html('');
        $(`${modal_cart} button.modal-close`).attr('data-url', null);
        $(modal_cart).addClass('hide');
    }

    function currency(number) {
        return (Math.round(number * 100) / 100).toFixed(2);
    }

    function urlCheckout() {
        return `${base_url}checkout/checkout`;
    }

    function urlAddress() {
        return `${base_url}account/address`;
    }

    function urlCart() {
        return `${base_url}checkout/cart`;
    }

    function urlAccount() {
        return `${base_url}account/account`;
    }

    function urlLogin() {
        return `${base_url}account/login`;
    }

    function urlEdit() {
        return `${base_url}account/editorder`;
    }

    function urlPaymentMethods() {
        return `${base_url}account/payments`;
    }

    function urlModuleOrder() {
        return `${base_url}module/order`;
    }

    function urlLogout(type = '') {
        return `${base_url}account/logout&type=${type}`;
    }

    function urlGiftVoucher() {
        return `${base_url}account/gift_voucher`;
    }

    function urlRewards() {
        return `${base_url}account/rewards`;
    }

    function urlFreeDelivery() {
        return `${base_url}account/free_delivery`;
    }

    function urlShop(show_box = false) {
        let url = $('div#lhs-categories-menu a.link:eq(1)').attr('href');
        if (show_box) {
            url += '&mybox=1';
        }
        return url;
    }

    function urlBraintree() {
        return 'https://cdn.jsdelivr.net/npm/braintree-web-drop-in@1.44.1/dist/browser/dropin.min.js';
    }

    function reCAPTCHAKey() {
        return '6Le9VaYaAAAAAAB8XFK14GLSX1Wsl8aIEMBBe9Fh';
    }

    function initMap() {
        const myLatLng = { lat: -33.907259, lng: 151.164961 };
        const map = new google.maps.Map(document.getElementById("google_maps"), {
            center: myLatLng,
            zoom: 14
        });
        new google.maps.Marker({
            position: myLatLng,
            map,
            title: 'Doorstep Organics',
            icon: '/dist/images/map_pin.svg',
            animation: google.maps.Animation.DROP,
        });
    }

    function showCategories(id) {
        const el = $(`${menu} a.sublink[data-id="${id}"]`);
        if (el.length > 0) {
            $(el).addClass('menubold');
            $(el).closest('ul.subcategory').addClass('in').css('height', 'auto');
            $(el).closest('li').find('a.link').addClass('active');
        } else {
            const el = $(`${menu} a.link[data-id="${id}"]`);
            if (el.length > 0) {
                $(el).addClass('active');
                $(el).parent('li').find('ul.subcategory').addClass('in').css('height', 'auto');
            }
        }
        $(menu).removeClass('hide');
    }

    function outputCart() {
        doorstep.cart_products.forEach(function (product) {
            //console.log(`%c${product.id} (${product.name} ${product.size_free}): ${product.in_cart}, ${product.edit_in_cart} (${(product.edit_product && product.price !== product.edit_price) ? product.edit_price : product.price})`, 'color:blue;font-weight:bold');
        });
    }

    function loadMoreMenu() {
        $(getMenuEl()).css('height', $('div#main-container').prop('offsetHeight'));
    }

    function getMenuEl() {
        if (doorstep.page_type === 'account') {
            return 'div#lhs-favourites-menu';
        }
        return 'div#lhs-categories-menu > ul';
    }

    function loadMoreResize() {
        $('div#load_more').css('width', $(doorstep.page_type === 'account' ? 'div#main-container' : 'div.grid').prop('offsetWidth') - (2 * rem()));
    }

    function onDesktop() {
        return $('div#mobile-nav').css('display') === 'none';
    }

    function logError(jqXHR, textStatus, errorThrown) {
        $.ajax({
            url: `${base_url}common/header/jserror`,
            type: 'post',
            data: { errorObj : JSON.stringify(jqXHR), textStatus : textStatus, errorThrown : errorThrown},
            dataType: 'json'
        })
    }

    function hasStorage(type) {
        let storage;
        try {
            storage = window[type];
            var x = '__storage_test__';
            storage.setItem(x, x);
            storage.removeItem(x);
            return true;
        }
        catch(e) {
            return e instanceof DOMException && (
                    e.code === 22 ||
                    e.code === 1014 ||
                    e.name === 'QuotaExceededError' ||
                    e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
                (storage && storage.length !== 0);
        }
    }

    function cspNonce() {
        $.ajax({
            url: `${base_url}common/header/csp_nonce`,
            type: 'post',
            dataType: 'json'
        })
    }

    $(document).ready(function () {

        $(modal_cart).find('img.close-modal, button.grey').on('click',function() {
            const url = $(this).attr('data-url');
            if (url !== undefined && url.length > 0) {
                location.href = url;
            } else {
                cartClose();
            }
        });

    });

    return {
        getEnv             : getEnv,
        getType            : getType,
        getView            : getView,
        getSubView         : getSubView,
        getKey             : getKey,
        getId              : getId,
        doModal            : doModal,
        htmlDecode         : htmlDecode,
        status             : status,
        state_to_zone      : state_to_zone,
        zone_to_state      : zone_to_state,
        url_param          : url_param,
        setNavSignOut      : setNavSignOut,
        getSelectedAddress : getSelectedAddress,
        dow                : dow,
        cartModal          : cartModal,
        currency           : currency,
        urlCheckout        : urlCheckout,
        urlAddress         : urlAddress,
        urlCart            : urlCart,
        urlAccount         : urlAccount,
        urlLogin           : urlLogin,
        urlEdit            : urlEdit,
        urlPaymentMethods  : urlPaymentMethods,
        urlModuleOrder     : urlModuleOrder,
        urlLogout          : urlLogout,
        urlGiftVoucher     : urlGiftVoucher,
        urlRewards         : urlRewards,
        urlFreeDelivery    : urlFreeDelivery,
        urlShop            : urlShop,
        urlBraintree       : urlBraintree,
        reCAPTCHAKey       : reCAPTCHAKey,
        initMap            : initMap,
        cartClose          : cartClose,
        showCategories     : showCategories,
        outputCart         : outputCart,
        loadMoreMenu       : loadMoreMenu,
        loadMoreResize     : loadMoreResize,
        onDesktop          : onDesktop,
        logError           : logError,
        hasStorage         : hasStorage,
        cspNonce           : cspNonce
    }

})(jQuery);